import {
  CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_BEGIN,
  CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_SUCCESS,
  CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_FAILURE,
  CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_DISMISS_ERROR,
  CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_WITH_IMAGES_SUCCESS,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW, REACT_APP_IMG } from '../../../common/config';
import { FILES_ENDPOINT } from 'cfgCommon/endpoints'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getCarDealerships(args = {}) {
  return async (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_BEGIN,
    });
    try {
      const res = await axios.get(REACT_APP_API_ABM_FW + "/abms/car_lot" + args);
      if (res.data.success) {
        let carDealerships = res.data.data;
        if (carDealerships.length > 0) {
          carDealerships.forEach(carDealership => {
            carDealership['logo'] = '';
            carDealership['logo_mini'] = '';
            carDealership['company_name'] = carDealership.Company.name;
            if (carDealership.Branch_offices.length === 0) {
              carDealership['canDelete'] = true;
            } else {
              carDealership['canDelete'] = false;
            }
            carDealership['files'] = {
              'LOGO': [],
              'FIRMA': [],
              'FIRMA_DIRECT_SALE': []
            };
          });
          if (args !== '') {
            // Dispatch sin fotos para carga rápida de datos
            dispatch({
              type: CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_SUCCESS,
              data: carDealerships,
              pagination: res.data.pagination
            });
            // Busca y agrega los link de las imágenes
            let carDealershipsWithImages = await getImages(carDealerships, 'logo')
            carDealershipsWithImages = await getImages(carDealershipsWithImages, 'firma')
            carDealershipsWithImages = await getImages(carDealershipsWithImages, 'firma_direct_sale')
            // Dispatch con los link de las imágenes, ejecuta otra acción para recargar el componente visual
            dispatch({
              type: CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_WITH_IMAGES_SUCCESS,
              data: carDealershipsWithImages,
              pagination: res.data.pagination
            });
            return res;
          } else {
            dispatch({
              type: CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_SUCCESS,
              data: carDealerships,
              pagination: res.data.pagination
            });
            return res;
          }
        } else {
          dispatch({
            type: CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_SUCCESS,
            data: [],
            pagination: {
              total: 0,
              page: 1,
              pages: 1,
              nextPage: null,
              prevPage: null
            }
          });
          return res;
        }
      } else {
        dispatch({
          type: CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_FAILURE,
          data: [],
          pagination: {
            total: 0,
            page: 1,
            pages: 1,
            nextPage: null,
            prevPage: null
          }
        });
        return;
      }
    }
    catch (err) {
      dispatch({
        type: CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_FAILURE,
        data: { error: err },
      });
      return err;
    }
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetCarDealershipsError() {
  return {
    type: CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getCarDealershipsPending: true,
        isImageLoad: false,
        getCarDealershipsError: null,
      };
      case CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_WITH_IMAGES_SUCCESS:
        return {
          ...state,
          getCarDealershipsPending: false,
          isImageLoad: true,
          getCarDealershipsError: null,
        };

    case CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_SUCCESS:
      // The request is success
      return {
        ...state,
        getCarDealershipsPending: false,
        getCarDealershipsError: null,
        carDealershipListOrigin: [...action.data],
        carDealershipList: [...action.data],
        carDealershipsPagination: { ...action.pagination }
      };

    case CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_FAILURE:
      // The request is failed
      return {
        ...state,
        getCarDealershipsPending: false,
        getCarDealershipsError: action.data.error,
      };

    case CAR_DATA_MASTER_GET_CAR_DEALERSHIPS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getCarDealershipsError: null,
      };

    default:
      return state;
  }
}

const getImages = async (carDealerships, imageType) => {
  try {
    const logoList = await Promise.all(carDealerships.map(async (car)=>{
      let resFiles = {};
      if(imageType !== "firma_direct_sale") {
        resFiles = await axios.get(FILES_ENDPOINT + `/CARDEARLERSHIP_${imageType.toUpperCase()}/` + car.id)
      } else {
        resFiles = await axios.get(FILES_ENDPOINT + `/DIRECTSALES_SIGN/` + car.id)
      }
      const item = await (resFiles).data.data
      // toUpperCase y toLowerCase se usan para indicar que el server manda ese Case en cada String a comparar
      if (item.length > 0) {
        car['files'][imageType.toUpperCase()] = item
        car[imageType.toLowerCase()] = REACT_APP_IMG + '/' + item[0].url
        car[`${imageType.toLowerCase()}_mini`] = REACT_APP_IMG + '/' + item[0].mini_url
      }
      return car
    }))
    return logoList
    
  } catch (error) {
      console.log('error: ', error)
    return []
    
  }
}
